export default {
	"exchange.inTheProduct": "商品中的",
	"exchange.HasBeenActivatedInOrderToAvoidMissingTheExperienceTimePleaseLogInToTheCallMiniProgramOrAppAsSoonAsPossibleToExperience": "已被啟動，為避免錯過體驗時間，請儘快登錄【叫叫】小程式或 App 進行體驗。",
	"exchange.ViewOrderDetails": "查看訂單詳情",
	"exchange.LongPressToIdentifyTheQRCode": "長按識別二維碼",
	"exchange.EnterTheCallMiniProgram": "進入叫叫小程式"
}